(function () {
    'use strict';
    $(document).ready(function () {

        var headElement = document.head || document.getElementsByTagName('head')[0];
        var fontStyleElement = document.createElement('style');

        var fontSizeType = {
            min: 'min',
            normal: 'normal',
            max: 'max'
        };

        var actualFontSizeType = fontSizeType.normal;

        function getFontSizes() {
            var sizes = {
                normal: 62.5,
                min: 47.5,
                max: 77.5
            };
            return sizes;
        }

        function setFontSize(type, setLocalStorage) {
            var size, css;
            if (type === fontSizeType.min)
                size = getFontSizes().min;
            else if (type === fontSizeType.max)
                size = getFontSizes().max;
            else
                size = getFontSizes().normal;

            css = 'html { font-size: ' + size + '%; }';
            if (fontStyleElement.styleSheet) {
                fontStyleElement.styleSheet.cssText = css;
            } else {
                while (fontStyleElement.firstChild) {
                    fontStyleElement.removeChild(fontStyleElement.firstChild);
                }
                fontStyleElement.appendChild(document.createTextNode(css));
            }

            if (setLocalStorage)
                localStorage.setItem('font-size', type);
        }

        function handleFontSize() {
            // on start
            fontStyleElement.type = 'text/css';
            headElement.appendChild(fontStyleElement);
            if (localStorage.getItem('font-size')) {
                actualFontSizeType = localStorage.getItem('font-size');
                setFontSize(actualFontSizeType, false);
            }

            // events
            $('.fontsize-trigger').on('click', function (e) {
                if(actualFontSizeType == fontSizeType.normal)
                    actualFontSizeType = fontSizeType.max;
                else if(actualFontSizeType == fontSizeType.max)
                    actualFontSizeType = fontSizeType.min;
                else if(actualFontSizeType == fontSizeType.min)
                    actualFontSizeType = fontSizeType.normal;

                setFontSize(actualFontSizeType, true);
                e.preventDefault();
                return false;
            });
        }

        function handleContrast() {
            // on start
            if (localStorage.getItem('contrast') && localStorage.getItem('contrast') === 'on') {
                $('.contrast-trigger').addClass('active');
                $('body').addClass('contrast');
            }

            // events
            $('.contrast-trigger').on('click', function (e) {
                if (localStorage.getItem('contrast') && localStorage.getItem('contrast') === 'on') {
                    localStorage.setItem('contrast', 'off');
                    $('.contrast-trigger').removeClass('active');
                } else {
                    localStorage.setItem('contrast', 'on');
                    $('.contrast-trigger').addClass('active');
                }
                $('body').toggleClass('contrast');
                e.preventDefault();
                return false;
            });
        }

        var body = $('body');
        body.on('click', '.send-to-printer', function () {
            // var w = window.open();
            // var htmlEl = $('html').clone();
            // var body = htmlEl.find('body');
            // body.html('<div class="content subpage printpage"></div>');
            // $('main').each(function () {
            //     body.find('.subpage').append($(this).html());
            // });
            // var html = htmlEl.html();
            // $(w.document.body).html(html).addClass('print-version');
            body.addClass('print-version');
            body.prepend('<button id="hide-print-version" class="blue-button">Ukryj wersję do druku</button>');
            $(document).scrollTop(0);
        });

        body.on('click', '#hide-print-version', function () {
            $(this).remove();
            $('body').removeClass('print-version');
        });

        $('.search-trigger .img-container').click(function () {
           var searchContainer = $(this).parent();
           searchContainer.toggleClass('hidden');
        });

        $(document).click(function() {
            var container = $('.search-trigger')
            if (!container.is(event.target) && !container.has(event.target).length) {
                container.addClass('hidden');                
            }
        });

        $(document).ready(function () {
            handleFontSize();
            handleContrast();
        });
    });
}(jQuery));
